package com.example.mystybag.core.helpers

import dev.icerock.moko.resources.ImageResource
import com.example.mystybag.core.expected.platformImageResource
import com.example.mystybag.core.resources.SRC
import com.example.mystybag.lib.setup.MystyBagLibSDK

fun appLogoImage(): ImageResource {
    return MystyBagLibSDK.logoResource?.let { platformImageResource(it) } ?: SRC.images.home_fill_icon
}

fun notificationLogoImage(): ImageResource {
    return MystyBagLibSDK.logoResource?.let { platformImageResource(it) } ?: SRC.images.home_fill_icon
}

fun homeButtonImage(): ImageResource {
    val rawHomeButtonResource = MystyBagLibSDK.homeButtonResource
    val resolved = rawHomeButtonResource?.let { platformImageResource(it) }

    return resolved ?: SRC.images.home_fill_icon
}